import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-fall-bild-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollFallBildHinzufuegenEffects {

    FunkprotokollFallBildHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN),
        mergeMap((x: ac.PostFunkprotokollFallBildHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollFallBildHinzufuegen(x.funkprotokollFallBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollFallBildHinzufuegenErfolgreichAction(result, x.funkprotokollFallBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollFallBildHinzufuegenFehlerAction(error, x.funkprotokollFallBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollCommandService);
        }
        return this.service;
    }
}
